import React from "react";
import DivisionTabsContainer from "../../containers/DivisionTabsContainer";
// import EditDivisionsCard from "./EditDivisionsCard";
import TeamInfoContainer from "../../containers/teams/TeamInfoContainer";
import AdminsContainer from "../../containers/admins/AdminsContainer";
import Grid from "@material-ui/core/Grid";
import TeamsTableContainer from "../../containers/teams/TeamsTableContainer";

const Teams = (props) => (
  <div>
    {!props.adminsPage && (
      <Grid container spacing={2} style={{ marginBottom: 5 }}>
        {/* <Grid item xs={12} sm={6} md={4}>
        <EditDivisionsCard
          tournament={props.tournament}
          divisions={props.divisions}
          tournamentStatus={props.tournamentStatus}
          toggleFinishedDialog={props.toggleFinishedDialog}
        />
      </Grid> */}
        <Grid item xs={12} sm={6} md={4}>
          <TeamInfoContainer
            tournament={props.tournament}
            refereesPage={props.refereesPage}
            handleToPlayersClick={props.handleToPlayersClick}
            handleToJudgesClick={props.handleToJudgesClick}
            days={props.days}
            teamsContactInfo={props.teamsContactInfo}
            playersContactInfo={props.playersContactInfo}
          />
        </Grid>
        {props.tournamentAdmin === undefined && false && (
          <Grid item xs={12} sm={6} md={4}>
            <AdminsContainer tournament={props.tournament} />
          </Grid>
        )}
      </Grid>
    )}
    {props.refereesPage || props.adminsPage ? (
      <TeamsTableContainer
        tournament={props.tournament}
        tournamentStatus={props.tournamentStatus}
        toggleFinishedDialog={props.toggleFinishedDialog}
        refereesPage={props.refereesPage}
        adminsPage={props.adminsPage}
        user={props.user}
        divisions={props.divisions}
        days={props.days}
        daysByKey={props.daysByKey}
        daysLoaded={props.daysLoaded}
      />
    ) : (
      <DivisionTabsContainer
        tournament={props.tournament}
        divisions={props.divisions}
        divisionsObject={props.divisionsObject}
        teamsContactInfo={props.teamsContactInfo}
        contactInfoLoaded={props.contactInfoLoaded}
        playersContactInfo={props.playersContactInfo}
        playersContactInfoLoaded={props.playersContactInfoLoaded}
        teamPage={true}
        tournamentStatus={props.tournamentStatus}
        toggleFinishedDialog={props.toggleFinishedDialog}
        user={props.user}
        days={props.days}
        daysByKey={props.daysByKey}
        daysLoaded={props.daysLoaded}
      />
    )}
  </div>
);

export default Teams;
